import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
}

import SpinnerAnimation from "@/features/shared/SpinnerAnimation.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    tabindex: "0",
    class: _normalizeClass([
      (__props.loading || __props.disabled) && 'cursor-not-allowed',
      !__props.loading && !__props.disabled && 'hover:shadow-md cursor-pointer',
      'relative flex-shrink-0 inline-flex justify-center py-2 px-4 shadow-sm text-sm font-medium rounded-md transition-all btn-action',
    ]),
    disabled: __props.loading || __props.disabled
  }, [
    _createElementVNode("span", {
      class: _normalizeClass([
        (__props.loading || __props.disabled) && 'opacity-40',
        !(__props.loading || __props.disabled) && 'opacity-100',
        'transition-opacity inline-flex items-center',
      ])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SpinnerAnimation)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})